// Personal copy supplied by Anurag. Keep Beyond Work content editable here.
export const beyondWork = {
  title: 'Beyond work',
  heading: 'A little perspective outside the screen.',
  paragraphs: [
    'Beyond engineering, I’m someone with a wide range of interests and an endless curiosity for new experiences.',
    'I love sports, trivia, adventurous pursuits, and connecting with people over shared interests and great conversations.',
    'Literature holds a special place in my life, from the magic of Harry Potter and the timeless storytelling of David Copperfield to the grounded realism of Premchand.',
    'I consider myself a person of many tastes, and I believe life is about continuously exploring new ones, broadening our perspectives, and redefining what a fulfilling lifestyle means as we grow.',
  ],
};

const imageDirectory = `${process.env.PUBLIC_URL}/images/portraits`;
export const personalPhotos = {
  blazer: {
    src: `${imageDirectory}/blazer-480.webp`,
    fallback: `${imageDirectory}/blazer-480.png`,
    srcSet: [320, 480, 800].map(width => `${imageDirectory}/blazer-${width}.webp ${width}w`).join(', '),
    alt: 'Anurag Kumar, Data Analyst and AI/ML engineer',
  },
  lake: {
    src: `${imageDirectory}/lake-800.webp`,
    srcSet: [480, 800, 1200].map(width => `${imageDirectory}/lake-${width}.webp ${width}w`).join(', '),
    alt: 'Anurag Kumar at a hilltop viewpoint overlooking a lake city',
  },
};
